import {
  EntityFormReducerAction,
  EntityFormReducerActionType,
  EntityFormReducerState
} from './interfaces';

export const ENTITY_FORM_REDUCER_INITIAL_STATE: EntityFormReducerState = {
  testConnectionTaskId: null,
  testConnectionError: null,
  testConnectionRunning: false,
  testConnectionSuccessful: false,
  saveFormError: null,
  savingForm: false,
  submitForm: false
};

export function EntityFormReducer(
  state: EntityFormReducerState,
  action: EntityFormReducerAction
): EntityFormReducerState {
  const { type, data } = action;

  switch (type) {
    case EntityFormReducerActionType.SAVE_TEST_CONNECTION_TASK_ID:
      return {
        ...state,
        testConnectionTaskId: data?.testConnectionTaskId || null
      };

    case EntityFormReducerActionType.INIT_TEST_CONNECTION:
      return {
        ...state,
        testConnectionRunning: true,
        testConnectionError: null,
        testConnectionSuccessful: false,
        saveFormError: null,
        savingForm: false,
        submitForm: false
      };

    case EntityFormReducerActionType.SAVE_TEST_CONNECTION_SUCCESS:
      return {
        ...state,
        testConnectionTaskId: null,
        testConnectionRunning: false,
        testConnectionError: null,
        testConnectionSuccessful: true,
        saveFormError: null,
        savingForm: false
      };

    case EntityFormReducerActionType.SAVE_TEST_CONNECTION_ERROR:
      return {
        ...state,
        testConnectionTaskId: null,
        testConnectionRunning: false,
        testConnectionError: data!.testConnectionError as string,
        testConnectionSuccessful: false,
        saveFormError: null,
        savingForm: false
      };

    case EntityFormReducerActionType.SAVE_FORM:
      return {
        ...state,
        saveFormError: null,
        savingForm: true
      };

    case EntityFormReducerActionType.SAVE_FORM_ERROR:
      return {
        ...state,
        testConnectionTaskId: null,
        testConnectionRunning: false,
        testConnectionError: null,
        testConnectionSuccessful: false,
        savingForm: false,
        saveFormError: data?.saveFormError as string
      };

    case EntityFormReducerActionType.SUBMIT_FORM:
      return {
        ...state,
        ...ENTITY_FORM_REDUCER_INITIAL_STATE,
        submitForm: true
      };

    default:
      return state;
  }
}
